import { IAction } from '../../../../../__core/Interfaces/IAction';
import COURSE_INSTANCE_ACTIONS from '../../../Actions/ActionTypes';
import { setMaxMinPointsForStudentInitState } from './InitState';

export const setMaxMinPointsForStudentInProgress = (
  state: Array<string> = setMaxMinPointsForStudentInitState,
  action: IAction<string>
): Array<string> => {
  switch (action.type) {
    case COURSE_INSTANCE_ACTIONS.SET_POINTS_FOR_STUDENT_START:
      return [...state, action.payload];

    case COURSE_INSTANCE_ACTIONS.SET_POINTS_FOR_STUDENT_FINISH:
      return [...state.filter((value) => value !== action.payload)];

    default:
      return state;
  }
};
